export default "__VITE_ASSET__D1Xdudu___"